import React from 'react';
import s from './s.module.less';

const WhatsNewOnKlarity: React.FC = () => {
    const handleClick = () => {
        window.open('https://klarityhealth.substack.com/', '_blank');
    };

    return (
        <div className={s.wrapper}>
            <h3 className={s.title}>What&apos;s new on Klarity</h3>
            <div className={s.card}>
                <div className={s.content}>
                    <div className={s.actionItem} onClick={handleClick}>
                        <span className={s.actionLabel}>
                            Read the provider Newsletter
                        </span>
                        <div className={s.arrowIcon}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                            >
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M12.2929 5.29289C12.6834 4.90237 13.3166 4.90237 13.7071 5.29289L17.7071 9.29289C18.0976 9.68342 18.0976 10.3166 17.7071 10.7071L13.7071 14.7071C13.3166 15.0976 12.6834 15.0976 12.2929 14.7071C11.9024 14.3166 11.9024 13.6834 12.2929 13.2929L14.5858 11H3C2.44772 11 2 10.5523 2 10C2 9.44772 2.44772 9 3 9H14.5858L12.2929 6.70711C11.9024 6.31658 11.9024 5.68342 12.2929 5.29289Z"
                                    fill="#374151"
                                />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WhatsNewOnKlarity;
